import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  CardImg,
  Col,
  Row,
  Button,
} from "reactstrap"
import { generateSlug, getAppDetailsLink } from "../../utils/seoUtils"
import { usePlatforms } from "../../contexts/PlatformsContext"

export default function AppCard({ key, gamedata }) {
  const { getPlatformDisplayName } = usePlatforms()
  return (
    <Link
      to={getAppDetailsLink(gamedata)}
      className=""
      state={{ app_id: key, data: gamedata }}
    >
      <Card
        className="app-card-container2 m-2"
        onClick={() => console.log("Card clicked!")} // Replace with your click handler
        style={{
          border: "none",
          cursor: "pointer", // Makes the card look clickable
          transition: "background-color 0.3s ease", // Smooth transition for hover effect
          minWidth: 250,
        }}
      >
        <Row className="g-0 align-items-center">
          <CardBody>
            <div className="d-flex flex-wrap gap-3">
              <CardImg
                className="img-fluid"
                src={gamedata?.image_url || "https://via.placeholder.com/50"}
                alt="image cap"
                style={{
                  minWidth: 80,
                  objectFit: "cover",
                  maxHeight: 150,
                  minHeight: 150,
                }}
              />
              <b className="text-break">{gamedata?.name || "Demo1"}</b>
            </div>
            <div className="mt-1">
              <p>{gamedata?.category || "category"}</p>
              <div className="d-flex flex-wrap justify-content-between ">
                <p>
                  <small className="text-muted">
                    {gamedata?.price?.amount == 0
                      ? "0"
                      : gamedata?.price?.amount}
                    {gamedata?.price?.currency || "USD"}
                  </small>
                </p>
                <p>
                  <small className="text-muted">
                    {gamedata?.platform ? getPlatformDisplayName(gamedata.platform) : "Unknown"}
                  </small>
                </p>
              </div>
            </div>
          </CardBody>
        </Row>
      </Card>
    </Link>
  )
}
